// src/components/PromoBar.jsx
import React from "react";
import { useAdmin } from "../context/AdminProvider";

export default function PromoBar() {
  const { promoText } = useAdmin();
  if (!promoText) return null;
  return (
    <div className="w-full bg-[#D4FF00] text-black text-center py-2 text-sm font-semibold shadow-md z-50">
      {promoText}
    </div>
  );
}
